/**
 * Camera capture via @capacitor/camera (native)
 * Web fallback: input[type=file] capture=environment
 */
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { isNative } from './platform.js';

export async function capturePhoto() {
  if (isNative()) {
    const photo = await Camera.getPhoto({
      quality: 70,
      allowEditing: false,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Camera,
      correctOrientation: true,
      width: 1280,
    });
    return {
      dataUrl: photo.dataUrl,
      format: photo.format || 'jpeg',
      source: 'capacitor-camera',
    };
  }

  return capturePhotoWeb();
}

function capturePhotoWeb() {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.capture = 'environment';
    input.hidden = true;
    document.body.appendChild(input);

    const cleanup = () => {
      input.remove();
    };

    input.addEventListener(
      'change',
      () => {
        const file = input.files?.[0];
        cleanup();
        if (!file) {
          reject(new Error('Không có ảnh được chọn'));
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          resolve({
            dataUrl: String(reader.result || ''),
            format: file.type.split('/')[1] || 'jpeg',
            source: 'web-file-input',
          });
        };
        reader.onerror = () => reject(new Error('Không đọc được ảnh'));
        reader.readAsDataURL(file);
      },
      { once: true }
    );

    input.addEventListener(
      'cancel',
      () => {
        cleanup();
        reject(new Error('Đã hủy chụp ảnh'));
      },
      { once: true }
    );

    input.click();
  });
}
